import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setDischargeNestedField } from "../../../../Redux/actions/dischargeActions";
import DischargeService from "../../../../Services/DischargeService";
import { Select } from "antd";

const { Option } = Select;

export default function TreatmentSummary() {
  const dispatch = useDispatch();
  const summary = useSelector(
    (state) => state.discharge?.dischargeTreatmentSummary || {}
  );

  const [optionsMap, setOptionsMap] = useState({
    IV_FLUID: [],
    OXYGEN_THERAPY: [],
    PROCEDURE: [],
    PHYSIOTHERAPY: [],
    DIET_PLAN: [],
    SURGERY: [],
  });

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        const payload = {
          status: 1,
          pageSize: 500,
        };
        const res = await DischargeService.getDischargeTreatments(payload);
        const data = res.data?.data || res.data?.content || res.data;
        
        if (Array.isArray(data)) {
          const newOptionsMap = {
            IV_FLUID: [],
            OXYGEN_THERAPY: [],
            PROCEDURE: [],
            PHYSIOTHERAPY: [],
            DIET_PLAN: [],
            SURGERY: [],
          };
          
          data.forEach((item) => {
            if (newOptionsMap[item.treatmentType] !== undefined) {
              newOptionsMap[item.treatmentType].push(item);
            }
          });
          
          setOptionsMap(newOptionsMap);
        }
      } catch (error) {
        console.error("Error fetching treatment options:", error);
      }
    };

    fetchOptions();
  }, []);

  const handleFieldChange = (field, value) => {
    dispatch(setDischargeNestedField("dischargeTreatmentSummary", field, value));
  };

  const handleChange = (type, value, option, descField, idField) => {
    handleFieldChange(descField, option ? option.children : "");
    handleFieldChange(idField, value || "");
  };

  return (
    <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm hover:shadow-md transition-shadow">
      <h3 className="text-sm font-bold text-teal-700 mb-3 flex items-center gap-2">
        <span className="w-2 h-2 rounded-full bg-teal-600"></span>
        4. Treatment Summary
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-xs font-semibold mb-1.5 text-gray-700">
            IV Fluids
          </label>
          <Select
            showSearch
            allowClear
            className="w-full text-xs"
            placeholder="Select IV Fluid"
            onChange={(value, option) =>
              handleChange("IV_FLUID", value, option, "ivFluidDesc", "ivFluid")
            }
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {optionsMap.IV_FLUID.map((opt) => (
              <Option key={opt.id} value={opt.treatmentCode}>
                {opt.treatmentName}
              </Option>
            ))}
          </Select>
        </div>

        <div>
          <label className="block text-xs font-semibold mb-1.5 text-gray-700">
            Oxygen Therapy
          </label>
          <Select
            showSearch
            allowClear
            className="w-full text-xs"
            placeholder="Select Oxygen Therapy"
            onChange={(value, option) =>
              handleChange(
                "OXYGEN_THERAPY",
                value,
                option,
                "oxygenTherapyDesc",
                "oxygenTherapyId"
              )
            }
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {optionsMap.OXYGEN_THERAPY.map((opt) => (
              <Option key={opt.id} value={opt.treatmentCode}>
                {opt.treatmentName}
              </Option>
            ))}
          </Select>
        </div>

        <div>
          <label className="block text-xs font-semibold mb-1.5 text-gray-700">
            Procedures
          </label>
          <Select
            showSearch
            allowClear
            className="w-full text-xs"
            placeholder="Select Procedure"
            onChange={(value, option) =>
              handleChange(
                "PROCEDURE",
                value,
                option,
                "procedureDesc",
                "procedureId"
              )
            }
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {optionsMap.PROCEDURE.map((opt) => (
              <Option key={opt.id} value={opt.treatmentCode}>
                {opt.treatmentName}
              </Option>
            ))}
          </Select>
        </div>

        <div>
          <label className="block text-xs font-semibold mb-1.5 text-gray-700">
            Physiotherapy
          </label>
          <Select
            showSearch
            allowClear
            className="w-full text-xs"
            placeholder="Select Physiotherapy"
            onChange={(value, option) =>
              handleChange(
                "PHYSIOTHERAPY",
                value,
                option,
                "physiotherapyDesc",
                "physiotherapyId"
              )
            }
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {optionsMap.PHYSIOTHERAPY.map((opt) => (
              <Option key={opt.id} value={opt.treatmentCode}>
                {opt.treatmentName}
              </Option>
            ))}
          </Select>
        </div>

        <div>
          <label className="block text-xs font-semibold mb-1.5 text-gray-700">
            Diet Plan
          </label>
          <Select
            showSearch
            allowClear
            className="w-full text-xs"
            placeholder="Select Diet Plan"
            onChange={(value, option) =>
              handleChange(
                "DIET_PLAN",
                value,
                option,
                "dietPlanDesc",
                "dietPlanId"
              )
            }
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {optionsMap.DIET_PLAN.map((opt) => (
              <Option key={opt.id} value={opt.treatmentCode}>
                {opt.treatmentName}
              </Option>
            ))}
          </Select>
        </div>

        <div>
          <label className="block text-xs font-semibold mb-1.5 text-gray-700">
            Surgery Details
          </label>
          <Select
            showSearch
            allowClear
            className="w-full text-xs"
            placeholder="Select Surgery Details"
            onChange={(value, option) =>
              handleChange(
                "SURGERY",
                value,
                option,
                "surgeryDetails",
                "surgeryDetailsId"
              )
            }
            filterOption={(input, option) =>
              (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
            }
          >
            {optionsMap.SURGERY.map((opt) => (
              <Option key={opt.id} value={opt.treatmentCode}>
                {opt.treatmentName}
              </Option>
            ))}
          </Select>
        </div>
      </div>

      <div className="mt-3">
        <label className="block text-xs font-semibold mb-1 text-gray-700">
          Treatment Comments / Hospital Course
        </label>
        <input
          type="text"
          value={summary.comments || ""}
          onChange={(e) => handleFieldChange("comments", e.target.value)}
          className="w-full text-xs border border-gray-200 rounded-md px-2.5 py-1.5 outline-none focus:border-teal-500 bg-white"
          placeholder="e.g. Patient responded well to the treatment and is stable for discharge."
        />
      </div>
    </div>
  );
}
